import { StoreViewWithState } from './storeViews'

export function findActiveStoreView(storeViews: StoreViewWithState[]) {
  return storeViews.find((sc) => sc.active)
}
